class VariantRadios extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateMedia();
        this.updateURL();
        this.updateFormID();
        this.updatePrice();
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant || !this.currentVariant.featured_media) return;
        const mediaItem = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        if (!mediaItem) return;
        mediaItem.parentElement.prepend(mediaItem); // mută imaginea variantei prima în slider
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateFormID() {
        const formInputs = document.querySelectorAll(`#product-form-${this.dataset.section} input[name="id"]`);
        formInputs.forEach((input) => {
            input.value = this.currentVariant.id;
        });
    }

    updatePrice() {
        if (!this.currentVariant) return;
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const id = `price-${this.dataset.section}`;
                const destination = document.getElementById(id);
                const source = html.getElementById(id);
                if (source && destination) destination.innerHTML = source.innerHTML;

                const price = document.getElementById(`price-${this.dataset.section}`);
                if (price) price.classList.remove('visibility-hidden');
            });
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-radios', VariantRadios);
